const meetingStart = r => require.ensure([], () => r(require('@/page/shmeeting/start')), 'shmeeting');
const meetingIndex = r => require.ensure([], () => r(require('@/page/shmeeting/index')), 'shmeeting');
const calendar = r => require.ensure([], () => r(require('@/page/shmeeting/calendar')), 'shmeeting');
const confirmOrder = r => require.ensure([], () => r(require('@/page/shmeeting/confirmOrder')), 'shmeeting');
const payment = r => require.ensure([], () => r(require('@/page/shmeeting/payment')), 'shmeeting');
const payresult = r => require.ensure([], () => r(require('@/page/shmeeting/payresult')), 'shmeeting');
const orders = r => require.ensure([], () => r(require('@/page/shmeeting/orders')), 'shmeeting');
const orderDetail = r => require.ensure([], () => r(require('@/page/shmeeting/orderDetail')), 'shmeeting');

// dr研发中心预约
const rdmeeting = r => require.ensure([], () => r(require('@/page/rdmeeting/home')), 'rdmeeting');
const rdpersonal = r => require.ensure([], () => r(require('@/page/rdmeeting/personal')), 'rdpersonal');

export default [{
	path: '/meeting/start',
	component: meetingStart,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/home',
	component: meetingIndex,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/confirm',
	component: confirmOrder,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/payment',
	component: payment,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/payresult',
	component: payresult,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/orders',
	component: orders,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/orders/detail',
	component: orderDetail,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
},{
	path: '/meeting/calendar',
	component: calendar,
	meta: {
		requireAuth: true,
		code: 'meeting',
	},
	
},{
	path: '/rdmeeting/home',
	component: rdmeeting,
	meta: {
		requireAuth: true,
		code: 'rdmeeting',
	},
},{
	path: '/rdmeeting/personal',
	component: rdpersonal,
	meta: {
		requireAuth: true,
		code: 'rdmeeting',
	},
}
]